import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppShell from './components/layout/AppShell';
import AuthInitializer from './components/auth/AuthInitializer';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LandingRoute from './components/auth/LandingRoute';
import PracticePage from './pages/PracticePage';
import LeaderboardPage from './pages/LeaderboardPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import LandingPage from './pages/LandingPage';
import TwoFALoginPage from './pages/TwoFALoginPage';
import TwoFASetupPage from './pages/TwoFASetupPage';
import VerifyEmailPage, { ResendVerificationPage } from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AddPhonePage from './pages/AddPhonePage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthInitializer />
      <Routes>
        {/* Landing — logged-out only; authed users → /practice */}
        <Route
          path="/"
          element={
            <LandingRoute>
              <LandingPage />
            </LandingRoute>
          }
        />

        {/* All app routes inside AppShell (header + main) */}
        <Route
          path="/*"
          element={
            <AppShell>
              <Routes>
                {/* ── Practice & public ── */}
                <Route path="/practice"    element={<PracticePage />} />
                <Route path="/leaderboard" element={<LeaderboardPage />} />

                {/* ── Auth: public ── */}
                <Route path="/login"    element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />

                {/* ── Auth: flows ── */}
                <Route path="/auth/2fa-login"             element={<TwoFALoginPage />} />
                <Route path="/auth/verify-email"          element={<VerifyEmailPage />} />
                <Route path="/auth/verify-email-sent"     element={<VerifyEmailPage />} />
                <Route path="/auth/resend-verification"   element={<ResendVerificationPage />} />
                <Route path="/auth/forgot-password"       element={<ForgotPasswordPage />} />
                <Route path="/auth/reset-password"        element={<ResetPasswordPage />} />
                <Route
                  path="/auth/add-phone"
                  element={
                    <ProtectedRoute>
                      <AddPhonePage />
                    </ProtectedRoute>
                  }
                />

                {/* ── Auth: protected ── */}
                <Route
                  path="/auth/2fa-setup"
                  element={
                    <ProtectedRoute>
                      <TwoFASetupPage />
                    </ProtectedRoute>
                  }
                />

                {/* ── Protected app pages ── */}
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute>
                      <SettingsPage />
                    </ProtectedRoute>
                  }
                />

                <Route path="*" element={<Navigate to="/practice" replace />} />
              </Routes>
            </AppShell>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
